module.exports = __webpack_public_path__ + "static/chocolate_clover-61059b6ddaad8e529af851f70eaf940f.jpg";